export default "__VITE_ASSET__CNWwRK84__"